export function mapPossibleActionToOptions(possibleActions = []) { 
  return possibleActions
    .map(opt => {
      return {
        value: opt.Action.action_code,
        name: opt.Action.action_label,
      }
    })
} //TODO: centralizar este archivo en uno solo para reutilizar
